import {useMutation} from '@tanstack/react-query'
import {useSnackbar} from 'notistack'
import api, {UpdateServer} from 'src/services/api'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'

export default function useUpdatedServer() {
  const {enqueueSnackbar} = useSnackbar()

  const mutation = useMutation({
    mutationFn: async (server: UpdateServer) => {
      return await api.server.update(server)
    },
    onSuccess: async () => {
      enqueueSnackbar('Servidor de integração atualizado com sucesso', {variant: 'success'})
    },
    onError: (error) => {
      handleErrorWithSnackbar(enqueueSnackbar, error, 'Não foi possível atualizar o servidor no momento')
    },
  })
  return mutation
}
